<template>
  <div class="field">
    <field-label v-if="label" v-bind="{ required, requiredClass, requiredText, hint, hintIcon, hintClass, description }">
      <slot/>
    </field-label>
    <p :class="['field-description', descriptionClass]" v-if="description">{{ description }}</p>
    <div class="control" :class="controlClass">
      <dropdown-wrapper class="selector-wrapper" ref="dropdown">
        <template slot="trigger" slot-scope="{ isActive, isFlipped }">
          <input
            readonly
            type="text"
            class="selector colour-selector input"
            :placeholder="promptLabel"
            :value="selected"
            :class="[{ 'is-active': isActive, 'is-flipped': isFlipped }, inputClass]"/>
        </template>
        <dropdown-item custom>
          <component :is="`${type}-colour-picker`" v-bind="config" :value="selected" @input="setSelection" />
        </dropdown-item>
      </dropdown-wrapper>
      <span class="colour-indicator" :style="{ backgroundColor: selected }">
        <span v-if="hasInvert" :style="{ color: inverted }">{{ invertText }}</span>
      </span>
      <icon v-if="rightIcon" :class="['is-right', iconClass]" :pack="rightIconPack" :type="rightIconType" :icon="rightIcon"/>
    </div>
    <field-error v-if="hasError" v-bind="{ error, errorClass, errorSymbol }"/>
  </div>
</template>

<script>
import tinycolor from 'tinycolor2'
import { getColourInvert } from '../../utilities/colour/get-colour-invert'
import * as props from '../mixins/props'
import * as computed from '../mixins/computed'

export default {

  mixins: [
    props.classes,
    props.describable,
    props.disabled,
    props.error,
    props.fullWidth,
    props.hintable,
    props.iconable,
    props.items,
    props.label,
    props.required,
    props.working,

    computed.hasError
  ],

  props: {
    value: {
      type: String,
      default: '',
      validator: value => Boolean(value) ? tinycolor(value).isValid() : true
    },
    type: {
      type: String,
      default: 'slider'
    },
    promptLabel: {
      type: String,
      default: 'Select a colour…',
    },
    emptyText: {
      type: String,
      default: 'No available colours.'
    },
    config: {
      type: Object,
      default: () => ({})
    },
    invertText: {
      type: String,
      default: 'A'
    },
    hasInvert: Boolean,
  },

  data: () => ({
    selected: null,
    inverted: null,
  }),

  computed: {
    controlClass() {
      return [
        'has-icons-left', // used for the colour indicator
        { 'has-icons-right': this.rightIcon }
      ]
    },
    inputClass() {
      return [{
        [this.errorClass]: this.hasError,
      }, this.classes]
    },
  },

  methods: {
    setInverted() {
      if (this.hasInvert && this.selected) {
        this.inverted = getColourInvert(this.selected).toHexString()
      }
    },
    setSelection(payload) {
      this.selected = payload.hex
      this.setInverted()
    }
  },

  watch: {
    selected(value) {
      this.$emit('input', value)
    },
    inverted(value) {
      this.$emit('invert', value)
    },
    value: {
      immediate: true,
      handler(value) {
        this.selected = value
        this.setInverted()
      }
    }
  },

}
</script>
